import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PreparedStatement } from '../model';

@Injectable()
export class BlurbService {
  blurb = new BehaviorSubject<PreparedStatement>(null);
  blurb$ = this.blurb.asObservable();

  setBlurb(blurb: PreparedStatement): void {
    this.blurb.next(blurb);
  }

  clearBlurb(): void {
    this.blurb.next(null);
  }
}
